"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PWSCustomFieldEntity = exports.SchoolsCustomFieldEntity = void 0;
var SchoolsCustomFieldEntity;
(function (SchoolsCustomFieldEntity) {
    SchoolsCustomFieldEntity["Facilities"] = "Schools";
    SchoolsCustomFieldEntity["Buildings"] = "Buildings";
    SchoolsCustomFieldEntity["Districts"] = "SchoolDistricts";
    SchoolsCustomFieldEntity["Fixtures"] = "SchoolFixtures";
    SchoolsCustomFieldEntity["Plans"] = "SchoolSamplingEvents";
    SchoolsCustomFieldEntity["Remediations"] = "Remediations";
    SchoolsCustomFieldEntity["Samples"] = "SchoolSamples";
    SchoolsCustomFieldEntity["Sample Results"] = "SchoolSampleResults";
})(SchoolsCustomFieldEntity = exports.SchoolsCustomFieldEntity || (exports.SchoolsCustomFieldEntity = {}));
var PWSCustomFieldEntity;
(function (PWSCustomFieldEntity) {
    PWSCustomFieldEntity["Locations"] = "Locations";
    PWSCustomFieldEntity["Lead Service Lines"] = "LeadServiceLines";
    PWSCustomFieldEntity["Samples"] = "PwsSamples";
    PWSCustomFieldEntity["Sample Results"] = "PwsSampleResults";
    PWSCustomFieldEntity["Service Lines"] = "ServiceLines";
    PWSCustomFieldEntity["Contacts"] = "Contacts";
})(PWSCustomFieldEntity = exports.PWSCustomFieldEntity || (exports.PWSCustomFieldEntity = {}));
//# sourceMappingURL=CustomFieldEntity.js.map